<mat-form-field appearance="fill" class="w-full" data-testid="plateSelector">
  <!-- <mat-label i18n>Сторона</mat-label> -->
  <mat-select
    i18n-placeholder
    [disabled]="disabled"
    placeholder="Сторона"
    [ngModel]="plate"
    (ngModelChange)="plateChange.emit($event)">
    <mat-option i18n [value]="thisPlateTypeEnum.Face">Лицевая</mat-option>
    <mat-option i18n [value]="thisPlateTypeEnum.Back">Обратная</mat-option>
  </mat-select>
</mat-form-field>
